module.exports = __webpack_public_path__ + "static/condo_ux-1-2c912ad1892d19c22550fe93d6024e10.jpg";